import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, getElementCenterPos, Grid, LL_H_C, LL_V_L, MenuBuilder, ModuleFE_Dialog, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, performAction, SimpleListAdapter, stopPropagation, TS_Input, TS_Table, TS_Tabs } from '@nu-art/thunderstorm-frontend/index';
import { _keys, _values, flatArray, merge, MUSTNeverHappenException, removeFromArrayByIndex, sortArray } from '@nu-art/ts-common';
import { DropDown_Values, DropDown_Variable, HCSDropDowns } from '../../../shared-components/index.js';
import { Dialog_EditMeasurementUnitSynonyms } from './Dialog_EditMeasurementUnitSynonyms.js';
import { ICONS } from '@app/styles';
import { expressionToValue } from '../expressionToValue/expressionToValue.js';
import { Component_TermsAndExpression } from '../../../expressions/ui/expression-builder/components/terms-and-expressions/Component_TermsAndExpression.js';
import { normalRangeToExpressionSingleFE } from '../normalRangeToExpressionFE/index.js';
import './Editors.scss';
import { valueType_EnumElement, valueType_Enumerated, valueType_Range, valueType_SubEnumerated, valueType_SubRange, valueType_Tuple } from '@app/hcs-shared/core';
import { ModuleFE_MeasurementUnit, ModuleFE_Value, ModuleFE_Variable, } from '../../../../_entity.js';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
const fullRangeToString = (fullRange) => {
    return `${fullRange?.[0]} - ${fullRange?.[1]}`;
};
const stringToFullRange = (str) => {
    const values = str.split('-').map(item => item.trim()).map(item => Number(item));
    return [values[0] || 0, values[1] || 0];
};
const TabId_SimpleEditor = 'simple';
const TabId_ComplexEditor = 'complex';
export class NormalRangeEditor extends TS_EditableItemComponentProto {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.fullRange = fullRangeToString(nextProps.value.data?.fullRange || [0, 0]);
        state.uiExpression = state.editable.item;
        state.editable.setOnChanged(async (editable) => {
            const _convertedData = expressionToValue(editable.item);
            nextProps.value.data = {
                ...nextProps.value.data,
                ..._convertedData
            };
            this.reDeriveState({ editable });
        });
        let convertedData;
        if (state.uiExpression) {
            convertedData = expressionToValue(state.uiExpression);
        }
        nextProps.value.data ??= {
            // @ts-ignore
            ...nextProps.value.data,
            ...convertedData
        };
        if (!convertedData)
            state.disableTable = true;
        if (state.disableTable && convertedData)
            state.disableTable = false;
        if (state.disableTable)
            state.selectedTag = TabId_ComplexEditor;
        return state;
    }
    // ######################## Logic ########################
    setFullRange = (range) => {
        this.props.value.data.fullRange = range;
        const fullRange = fullRangeToString(range);
        this.setState({ fullRange });
    };
    setFullRangeString = (fullRange) => {
        try {
            this.props.value.data.fullRange = stringToFullRange(fullRange);
        }
        finally {
            this.setState({ fullRange });
        }
    };
    onCreateMeasurementUnit = async (text, items) => {
        // this change was applied due to incorrect approach thinking that we cannot allow creating new units when the adapter still has options
        // this is incorrect due to the fact that sometimes results may come up but be irrelevant so I switched to this check
        const duplicate = items.find(mUnit => mUnit.unitAsString.toLowerCase().trim() === text.trim().toLowerCase());
        if (duplicate)
            return;
        const titles = {
            inProgress: 'Creating New Measurement Unit',
            success: 'Measurement Unit Created',
            failed: 'Measurement Unit Creation Failed'
        };
        await performAction(async () => {
            const unit = {
                unitAsString: text,
                units: [text]
            };
            const newUnit = await ModuleFE_MeasurementUnit.v1.upsert(unit).executeSync();
            this.props.value.data.measurementUnit = newUnit;
            this.forceUpdate();
        }, { type: 'notification', notificationLabels: titles });
    };
    // ######################## Render ########################
    renderFullRange = () => {
        const range = stringToFullRange(this.state.fullRange);
        return _jsxs(LL_H_C, { className: 'dialog__main__section-item', children: [_jsxs(LL_V_L, { children: [_jsx("div", { className: 'dialog__field-title', children: "Full Range" }), _jsx(TS_Input, { className: 'range-full', type: 'text', value: this.state.fullRange, onChange: fullRange => {
                                this.setFullRangeString(fullRange);
                            } })] }), _jsxs(LL_V_L, { children: [_jsx("div", { className: 'dialog__field-title', children: "Full Range - Min" }), _jsx(TS_Input, { className: 'range-min', type: 'number', value: String(range[0]), onChange: value => this.setFullRange([Number(value), range[1]]) })] }), _jsxs(LL_V_L, { children: [_jsx("div", { className: 'dialog__field-title', children: "Full Range - Max" }), _jsx(TS_Input, { className: 'range-max', type: 'number', value: String(range[1]), onChange: value => this.setFullRange([range[0], Number(value)]) })] })] });
    };
    renderUnitsDropDown = () => {
        const data = this.props.value.data;
        return _jsxs(LL_H_C, { className: 'dialog__main__section-item', children: [_jsx("div", { className: 'dialog__field-title', children: "Units" }), _jsx(HCSDropDowns.MeasurementUnit, { selected: data.measurementUnit?._id, onSelected: (units) => {
                        this.props.value.data.measurementUnit = units;
                        this.forceUpdate();
                    }, onNoMatchingSelectionForString: this.onCreateMeasurementUnit }), data.measurementUnit && _jsx(ICONS.edit.component, { className: 'clickable', onClick: () => Dialog_EditMeasurementUnitSynonyms.show(data.measurementUnit, (updatedUnit) => {
                        this.props.value.data.measurementUnit = updatedUnit;
                        this.forceUpdate();
                    }) })] });
    };
    renderValueBuildingTabs = () => {
        return _jsx(TS_Tabs, { selectedTabId: this.state.selectedTag, onSelected: selectedId => this.setState({ selectedTag: selectedId }), tabs: [
                {
                    uid: TabId_SimpleEditor,
                    title: 'Edit Simple Range',
                    content: () => _jsx(NormalValuesTable, { onChange: () => {
                            const expression = merge(this.state.editable.item, normalRangeToExpressionSingleFE({ value: this.props.value }));
                            if (expression)
                                return this.state.editable.updateItem(expression);
                            this.reDeriveState();
                        }, value: this.props.value, editable: true }),
                    disabled: this.state.disableTable
                },
                {
                    uid: TabId_ComplexEditor,
                    title: 'Edit Complex Range',
                    content: () => _jsx(Grid, { className: 'expression-grid', children: _jsx(Component_TermsAndExpression, { editable: this.state.editable, hideDnD: true }) })
                }
            ] });
    };
    render() {
        return _jsxs(LL_V_L, { className: 'normal-range-editor', children: [_jsxs(LL_V_L, { className: 'dialog__main__section', style: { flexShrink: 0, maxHeight: '100px' }, children: [this.renderUnitsDropDown(), this.renderFullRange()] }), _jsx(LL_V_L, { className: 'dialog__main__section tabs-container', children: this.renderValueBuildingTabs() })] });
    }
}
export class NormalValuesTable extends ComponentSync {
    normalHeader = 'Standard Range';
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.varIdScopeMap = {};
        state.variableNameMap = {};
        state.valueNameMap = {};
        const declarationVarIdVariables = ModuleFE_Variable.cache.filter(item => nextProps.value.data.declarationVarIds.includes(item._id));
        //Construct name map
        declarationVarIdVariables.forEach(variable => state.variableNameMap[variable._id] = variable.name);
        const allDbValues = ModuleFE_Value.cache.all();
        //Construct value connection maps
        declarationVarIdVariables.forEach(variable => {
            const value = allDbValues.find(dbValue => dbValue._id === variable.valueId);
            if (value.type === valueType_Range)
                return state.varIdScopeMap[variable._id] = value.data?.subsets || [];
            if ([valueType_Enumerated, valueType_SubEnumerated, valueType_Tuple].includes(value?.type))
                return state.varIdScopeMap[variable._id] = value.data?.scope || [];
        });
        const valIdsToName = flatArray(_values(state.varIdScopeMap));
        valIdsToName.forEach(id => {
            const val = allDbValues.find(i => i._id === id);
            if (val.type === valueType_EnumElement)
                state.valueNameMap[id] = val.data.value;
            if (val.type === valueType_SubRange)
                state.valueNameMap[id] = val.data.label;
        });
        return state;
    }
    // ######################## Logic ########################
    handleHeaderContextMenu = (e, variableId) => {
        if (!this.props.editable)
            return;
        stopPropagation(e);
        const menuItems = [{
                label: 'Add Variable',
                onClick: () => {
                    Dialog_AddNormalVariable.show(variable => {
                        this.props.value.data.declarationVarIds.push(variable._id);
                        this.reDeriveState();
                    });
                }
            }];
        if (variableId !== this.normalHeader) {
            menuItems.push({
                label: 'Remove Variable',
                onClick: async () => {
                    const variableIds = this.props.value.data.declarationVarIds;
                    variableIds.splice(variableIds.indexOf(variableId), 1);
                    this.forceUpdate(() => this.props.onChange?.());
                }
            });
        }
        const adapter = SimpleListAdapter(menuItems, renderer => _jsx("div", { className: 'node-data', children: renderer.item.label }));
        const modalId = 'normal-value-menu';
        const pos = getElementCenterPos(e.currentTarget);
        new MenuBuilder(adapter, pos, { x: 0, y: 1 })
            .setId(modalId)
            .setOnClick((path, item) => {
            ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
            item.onClick?.();
        })
            .setOffset({ x: 0, y: 10 })
            .show();
    };
    getTableHeaders = () => {
        const headers = [...this.props.value.data.declarationVarIds, this.normalHeader].map(i => ({
            header: i,
            widthPx: 200
        }));
        if (this.props.editable)
            headers.push({ header: 'delete', widthPx: 50 });
        return headers;
    };
    getTableRows = () => {
        let values = this.props.value.data?.normalValues || [];
        values = sortArray(values, val => _keys(val.conditions).length === 0 ? 1 : 0);
        if (this.props.editable)
            return [...values, { range: [0, 0], conditions: {} }];
        return values;
    };
    deleteRow = (index) => {
        this.logInfo(`Deleteing index ${index}`);
        removeFromArrayByIndex(this.props.value.data.normalValues, index);
        this.forceUpdate(() => this.props.onChange?.());
    };
    // ######################## Render ########################
    renderTableHeader = (header) => {
        if (header === 'delete')
            return _jsx("div", {});
        return _jsx("div", { children: header === this.normalHeader ? this.normalHeader : this.state.variableNameMap[header] });
    };
    render() {
        const rows = this.getTableRows();
        return _jsxs(LL_V_L, { style: { width: '100%' }, children: [this.props.editable &&
                    _jsx("div", { className: 'dialog__field-title', children: "Normal Table" }), _jsx("div", { className: 'dialog__field-content', style: { width: '100%' }, children: _jsx(TS_Table, { header: this.getTableHeaders(), th: header => ({
                            onContextMenu: e => this.handleHeaderContextMenu(e, header)
                        }), headerRenderer: this.renderTableHeader, rows: rows, cellRenderer: (prop, item, index) => {
                            switch (prop) {
                                case this.normalHeader: {
                                    if (this.props.editable)
                                        return _jsx(TS_Input, { type: 'text', value: fullRangeToString(item.range), onBlur: val => {
                                                const range = stringToFullRange(val);
                                                if (range[0] === 0 && range[1] === 0)
                                                    return;
                                                item.range = range;
                                                if (index === rows.length - 1)
                                                    this.props.value.data?.normalValues.push(item);
                                                this.forceUpdate(() => this.props.onChange?.());
                                            } });
                                    return _jsx("div", { children: fullRangeToString(item.range) });
                                }
                                case 'delete':
                                    return _jsx(ICONS.bin.component, { onClick: () => index !== rows.length - 1 && this.deleteRow(index) });
                                default: {
                                    if (this.props.editable) {
                                        const variable = ModuleFE_Variable.cache.unique(prop);
                                        if (!variable)
                                            throw new MUSTNeverHappenException(`Could not find variable for id ${prop}}`);
                                        return _jsx(DropDown_Values, { queryFilter: val => this.state.varIdScopeMap[prop]?.includes(val._id), selected: item.conditions[prop], onSelected: val => {
                                                item.conditions[prop] = val._id;
                                                if (index === rows.length - 1)
                                                    this.props.value.data?.normalValues.push(item);
                                                this.forceUpdate(() => this.props.onChange?.());
                                            }, variable: variable });
                                    }
                                    return _jsx("div", { children: this.state.valueNameMap[item.conditions[prop]] });
                                }
                            }
                        } }) })] });
    }
}
export class Dialog_AddNormalVariable extends ComponentSync {
    // ######################## Static ########################
    static show(onSave) {
        ModuleFE_Dialog.show({
            content: _jsx(Dialog_AddNormalVariable, { onSave: onSave }),
            closeOverlayOnClick: () => false
        });
    }
    // ######################## Logic ########################
    closeDialog = () => {
        ModuleFE_Dialog.close();
    };
    saveVariable = async () => {
        await performAction(async () => {
            try {
                this.setState({ saveInProgress: true });
                this.props.onSave(this.state.selectedVar);
                this.closeDialog();
            }
            catch (e) {
                this.logError(e);
            }
            finally {
                this.setState({ saveInProgress: false });
            }
        }, { type: 'notification', notificationLabels: 'Saving Variable' });
    };
    // ######################## Render ########################
    render() {
        return (_jsxs(LL_V_L, { className: "dialog dialog__add-normal-variable", children: [this.renderHeader(), this.renderMain(), this.renderButtons()] }));
    }
    renderMain() {
        return _jsx(LL_V_L, { className: 'dialog__main', children: _jsx(DropDown_Variable, { queryFilter: () => true, selected: this.state.selectedVar, onSelected: selectedVar => {
                    this.setState({ selectedVar });
                } }) });
    }
    renderHeader() {
        return _jsxs(LL_H_C, { className: "dialog__header", children: [_jsx("span", { className: "title-text", children: "Add Normal Variable" }), _jsx(ICONS.x.component, { className: "exit_icon", onClick: this.closeDialog })] });
    }
    renderButtons() {
        return _jsxs(LL_H_C, { className: "dialog__buttons", children: [_jsx(Button, { variant: 'secondary', onClick: this.closeDialog, children: "Cancel" }), _jsx(Button, { variant: 'primary', onClick: this.saveVariable, className: _className(this.state.selectedVar ? 'desired-action-button' : undefined), disabled: this.state.saveInProgress, children: "Save" })] });
    }
}
//# sourceMappingURL=NormalRangeEditor.js.map